import React, { Component } from 'react'

import { makeDefaultFailedContainer } from 'components/container'
import ConnectedToSlack from './ConnectedToSlack'
import ConnectToSlack from './ConnectToSlack'
import EmailPrompt from './EmailPrompt'
import PendingTemplate from './PendingTemplate'

export class MobileLander extends Component {
  state = {}

  componentWillReceiveProps(nextProps) {
    const tokenStateChanged =
      nextProps.accessTokenCreationState['slack'] !==
      this.props.accessTokenCreationState['slack']
    if (tokenStateChanged) {
      this.setState({ connecting: false })
      // refresh the integration state
      // TODO ask backend for a freaking real time pusher event
      this.app.queries.IntegrationsQueries.fetchIntegrationStates()
    }
  }

  componentDidMount() {
    const { code } = this.props.location.query
    if (code) {
      this.setState({ connecting: true })
      this.app.queries.IntegrationsQueries.createSlackBotToken(code, `${ window.location.origin }${ window.location.pathname }`)
    }
  }

  render() {
    if (this.state.connecting) {
      return PendingTemplate
    }
    const connected = this.props.integrationStates['slackBot']
    const isInstalled = this.props.orgProperties['segmentEnabled'] || this.props.orgProperties['orgActivated']
    const isSignedUp = this.props.orgProperties['signUpDone']

    if (!isInstalled || !isSignedUp) {
      return <EmailPrompt />
    } else if (connected) {
      return <ConnectedToSlack channel={ this.props.integrationStates.slackChannel }/>
    } else {
      return ConnectToSlack
    }
  }
}

export const container = makeDefaultFailedContainer(MobileLander, {
  listenTo: ['stores.IntegrationsStore', 'stores.OrgPropertiesStore'],
  fetch: {
    integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates()
    },
    accessTokenCreationState() {
      return this.app.stores.IntegrationsStore.getAccessTokenCreationState()
    },
    orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg()
    }
  }
})



// WEBPACK FOOTER //
// ./src/scripts/components/MobileLander/index.js